module.exports = "/_next/static/images/game-1-intro-tutorial-suspects-text-uv-e6b58bfdfedbc50dcb8a895ab79b975d.png";